module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "main-app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container maincontent"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5 leftcontent",
    staticStyle: {
      "opacity": "0"
    }
  }, [(_vm.overallData.organization) ? _c('store-selection', {
    staticClass: "storeselector",
    attrs: {
      "overallData": _vm.overallData,
      "gApiLoaded": _vm.gApiLoaded
    },
    on: {
      "storeissselected": _vm.storeissselected,
      "reviewisselected": _vm.reviewisselected
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7"
  }, [(_vm.storeSelected.loupeid) ? _c('result-with-filter', {
    attrs: {
      "storeSelected": _vm.storeSelected,
      "reviewSelected": _vm.reviewSelected
    }
  }) : _vm._e(), _vm._v(" "), (_vm.totalCountOfResultsDisplayedInResultComponenet > 3 && _vm.showResultMainContent && _vm.scrollTopSpace > 200) ? _c('div', {
    staticClass: "d-flex justify-content-end align-items-end",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "fixed",
      "bottom": "20px"
    }
  }, [_c('a', {
    staticClass: "backtotopA",
    attrs: {
      "href": "BackToTop"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.scrollTop($event)
      }
    }
  }, [_c('div', {
    staticClass: "mx-auto backtotopbtn"
  }), _vm._v(" "), _c('img', {
    staticClass: "droparrow",
    staticStyle: {
      "position": "absolute",
      "top": "16px",
      "left": "7px",
      "width": "28px"
    },
    attrs: {
      "src": "builds/l_up_arrow.svg",
      "alt": "drop arrow"
    }
  })])])]) : _vm._e()], 1)])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topheader topheaderheight"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "loupeheaderlogo"
  }, [_c('p', {
    staticClass: "logotxt"
  }, [_vm._v("LOUPE")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-center align-items-center topheaderheight pagetitle"
  }, [_c('h3', [_vm._v("Customer Reviews")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer mx-auto small m-5 "
  }, [_c('p', {
    staticClass: "color2"
  }, [_vm._v("All reviews submitted by actual Apex Energy Solutions customers through the LOUPE SSG Platform.")]), _vm._v(" "), _c('p', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Powered by LOUPE®")]), _vm._v(" "), _c('p', {
    staticClass: "lastline"
  }, [_vm._v("©2018 Touchstone Media Group, LLC")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-360788d6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./process/App.vue
// module id = 160
// module chunks = 0